import { render } from "./LoginComponentOTP.vue?vue&type=template&id=d94b9154&scoped=true&ts=true"
import script from "./LoginComponentOTP.vue?vue&type=script&lang=ts"
export * from "./LoginComponentOTP.vue?vue&type=script&lang=ts"

import "./LoginComponentOTP.vue?vue&type=style&index=0&id=d94b9154&scoped=true&lang=css"
import "./LoginComponentOTP.vue?vue&type=style&index=1&id=d94b9154&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d94b9154"]])

export default __exports__